<template>
  <div class="infor fl">
    <AllHeader :label="lable" />
    <!-- <Allylist :step="step" @closepop="closepop" v-if="ispaly"/> -->
    <div v-if="!isAllylist">
      <div class="stpcontiner">
        <div v-for="(item,index) in list" :key="index" style="display: flex;align-items: center">
          <div class="stpietrn">
            <span>{{item.name}}</span>
          </div>
          <div class="line" v-if="index<list.length-1"></div>
          <img src="../assets/right.png" alt v-if="index<list.length-1" />
          <div class="line" v-if="index<list.length-1"></div>
        </div>
      </div>
      <Lineconbgtir :labelcontainer="labelcontainertow" />
      <div class="bannerlisne">
        <el-popover
          placement="top-start"
          title="标题"
          width="200"
          trigger="hover"
          content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
          <div class="banner banerone" slot="reference">
            <span style="font-size: 14px;color: white;font-weight: bold">理事单位</span>
            <div class="mnunbutton" v-if="level_3" @click="appl(0)">
              <span>立即申请</span>
            </div>
            <div class="mnunbutton" v-else>
              <span>已申请</span>
            </div>
          </div>
        </el-popover>
        <el-popover
          placement="top-start"
          title="标题"
          width="200"
          trigger="hover"
          content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
        <div class="banner banertwo" slot="reference">
          <span style="font-size: 14px;color: white;font-weight: bold">常务理事单位</span>
          <div class="mnunbutton" v-if="level_4" @click="appl(1)">
            <span>立即申请</span>
          </div>
          <div class="mnunbutton" v-else>
            <span>已申请</span>
          </div>
        </div>
        </el-popover>
        <el-popover
          placement="top-start"
          title="标题"
          width="200"
          trigger="hover"
          content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
        <div class="banner banerthree" slot="reference">
          <span style="font-size: 14px;color: white;font-weight: bold">副会长单位</span>
          <div class="mnunbutton" v-if="level_5" @click="appl(2)">
            <span>立即申请</span>
          </div>
          <div class="mnunbutton" v-else>
            <span>已申请</span>
          </div>
        </div>
        </el-popover>
      </div>
        
      <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisiblepay" width="30%">
        <div style="display: flex;flex-direction: column;align-items: center">
          <p style="font-size: 16px;color: #333333;margin: 10px 0" v-if="isapple">是否确认申请升级会员？</p>
          <p
            style="font-size: 16px;color: #333333;margin: 10px 0;width: 60%;text-align: center"
            v-if="!isapple"
            v-html="tips"
          ></p>
          <div
            style="display: flex;justify-content: center;align-items: center;width: 90%;margin: 20px 0"
          >
            <el-button
              style="color: #194ABE;border: 1px solid #194ABE;width: 48%"
              @click="dialogVisiblepay=false"
              v-if="!isapple"
            >我知道了</el-button>
            <el-button style="width: 48%" @click="dialogVisiblepay=false" v-if="isapple">取消</el-button>
            <el-button
              style="color: #194ABE;border: 1px solid #194ABE;width: 48%"
              @click="ispaye()"
              v-if="isapple"
            >确认申请</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div v-if="isAllylist">
      <Allylist :step="true" :applaylevel="index"></Allylist>
    </div>
  </div>
</template>

<script>
import Allylist from "./Modal/Allylist";
import AllHeader from "@/components/Modal/AllHeader";
import Lineconbgtir from "./Modal/Line";
import { GetMember } from "../utils/api.js";
export default {
  name: "upgrade",
  components: {
    Allylist,
    AllHeader,
    Lineconbgtir
  },
  data() {
    return {
      level: {},
      level_5: false,
      level_4: false,
      level_3: false,
      step: 1,
      dialogVisiblepay: false,
      lable: "",
      // ispaly:false,
      index: 0,
      isapple: true,
      labelcontainertow: {
        lable: "选择要申请的等级",
        desc: "Application Notes"
      },
      list: [
        {
          name: "会员单位"
        },
        {
          name: "理事单位"
        },
        {
          name: "常务理事单位"
        },
        {
          name: "副会长单位"
        }
      ],
      applist: ["理事单位", "常务理事单位", "副会长单位"],
      member: {},
      isAllylist: false,
      tips: "您还没有升级成为理事单位,<br/>无法申请成为副会长单位"
    };
  },
  created() {
    this.lable = this.$route.query.name;
    this.initData();
    this.member.then(res => {
      const level = res.level;
      this.level = level;
      if (this.level == 1||this.level == 0) {
        this.level_3 = true;
        this.level_4 = true;
        this.level_5 = true;
        return false
      }
      if (this.level == 2) {
        this.level_4 = true;
        this.level_5 = true;
        return false
      }
      if (this.level == 3) {
        this.level_5 = true;
        return false
      }
      this.level_3 = false;
      this.level_4 = false;
      this.level_5 = false;
    });
  },
  mounted() {},
  methods: {
    async initData() {
      let member = GetMember();
      this.member = member;
    },
    closepop(step) {
      this.step = step;
    },
    appl(index) {
      let tipsbefor = "您还没有升级成为";
      let tipsaffter = "无法申请成为";
      let index_0 = "理事单位";
      let index_1 = "常务理事单位";
      let index_2 = "副会长单位";
      this.member.then(res => {
        const level = res.level;
        this.level = level;
        this.dialogVisiblepay = true;
        switch (level) {
          case 0:
            this.isapple = false;
            this.tips = `${tipsbefor}会员,<br/>不能进行会员升级`;
            break;
          case 1:
            if (index == 0) {
              this.isapple = true;
              this.index = index;
              return false;
            }
            if (index == 1) {
              this.isapple = false;
              this.tips = `${tipsbefor}${index_0},<br/>${tipsaffter}${index_1}`;
              return false;
            }
            if (index == 2) {
              this.isapple = false;
              this.tips = `${tipsbefor}${index_0},<br/>${tipsaffter}${index_2}`;
              return false;
            }
            break;
          case 2:
            if (index == 1) {
              this.isapple = true;
              this.index = index;
            } else {
              this.isapple = false;
              this.tips = `${tipsbefor}${index_1},<br/>${tipsaffter}${index_2}`;
            }
            break;
          case 3:
            if (index == 2) {
              this.isapple = true;
              this.index = index;
            }
            break;
          case 4:
            if (index == 3) {
              this.isapple = true;
              this.index = index;
            }
            break;
          default:
            break;
        }
      });
      console.log(index);
    },
    ispaye() {
      //是否能神请的开关
      let appleuyr = true;
      if (appleuyr) {
        this.lable = "申请成为" + this.applist[this.index];
        this.dialogVisiblepay = false;
        this.isAllylist = true;

        // this.ispaly=true;
      } else {
        // this.isapple=false;
      }
    }
  }
};
</script>
<style scoped lang="less">
.stpcontiner {
  width: 100%;
  height: 140px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 10px;
    height: auto;
  }

  .stpietrn {
    display: flex;
    width: 85px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #194abe;
    opacity: 1;
    border-radius: 8px 0px 8px 0px;
    align-items: center;
    font-size: 12px;
    justify-content: center;
    color: #194abe;
  }

  .line {
    width: 70px;
    height: 2px;
    border-top: 1px dashed #194abe;
  }
}

.bannerlisne {
  width: 60%;
  display: flex;
  height: 300px;
  justify-content: space-around;
  margin: 30px 0 0 40px;
  margin-left: 20%;

  .banner {
    width: 150px;
    height: 200px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-end;
  }

  .mnunbutton {
    width: 78px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #ffffff;
    background: #ffffff;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 13px;
    margin: 30px 0 10px 0;
    cursor: pointer;
  }

  .banerone {
    background: url("../assets/onbanner.png") no-repeat top;
    background-size: contain;
  }

  .banertwo {
    background: url("../assets/twobanner.png") no-repeat top;
    background-size: contain;
  }

  .banerthree {
    background: url("../assets/threebanner.png") no-repeat top;
    background-size: contain;
  }
}
</style>
